export default "__VITE_ASSET__DmB813an__"